import React from 'react';
import { formatAttendanceHm } from '../utils/attendanceTime';

/** Hora de salida; muestra (+1 día) si cerró la jornada del día anterior al día siguiente. */
export function AttendanceCheckOutTime({ iso, checkOutNextDay, className = '' }) {
  const hm = formatAttendanceHm(iso);
  if (hm === '—') return <span className={className}>{hm}</span>;
  return (
    <span className={`inline-flex flex-wrap items-center gap-1 ${className}`.trim()}>
      <span className="tabular-nums">{hm}</span>
      {checkOutNextDay && (
        <span className="text-xs text-slate-500 whitespace-nowrap" title="Salida al día siguiente">
          (+1 día)
        </span>
      )}
    </span>
  );
}
